import { render } from "./ViewTransfertMagasinPage.vue?vue&type=template&id=21f1feff&ts=true"
import script from "./ViewTransfertMagasinPage.vue?vue&type=script&lang=ts"
export * from "./ViewTransfertMagasinPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__